import { DrawerFooter } from "@fluentui/react-components";
import { ROUTES } from "library/routes";
import { useLocation } from "react-router-dom";

import { NavFooterContent } from "components/NavFooterContent/NavFooterContent";
import { useIsMobile } from "hooks/useIsMobile";

export const NavFooter = () => {
  const pathname = useLocation()?.pathname;
  const isDesktop = !useIsMobile();

  const isHomePage = pathname === ROUTES.HOME;
  const isPaletteDemo = pathname === "/palette-demo";

  if (!isDesktop || isHomePage || isPaletteDemo) return null;

  return (
    <DrawerFooter
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
      }}
    >
      <NavFooterContent />
    </DrawerFooter>
  );
};
